import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider, SupportProvider } from '../contexts';
import AppRoutes from '../Routes';

import { ThemeProvider } from '@/components/theme-provider';

function App() {

  return (
    <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
      <AuthProvider>
        <SupportProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </SupportProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
